import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './styles/main.scss';
import 'video-react/dist/video-react.css';
import App from './components/app';
import * as serviceWorker from './serviceWorker';
import {HashRouter} from 'react-router-dom';
import TagManager from 'react-gtm-module'
import * as Sentry from '@sentry/react';
import { BrowserTracing } from "@sentry/tracing";
import { AudioPlayerProvider } from 'contexts/audio-context';

const tagManagerArgs = {
  gtmId: 'GTM-5PQWCK5'
}

TagManager.initialize(tagManagerArgs)

Sentry.init({
  dsn: "https://60a59603646341e595367b21e81bbe45@o1193379.ingest.sentry.io/6315641",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  enabled: process.env.NODE_ENV !== 'development',
});

ReactDOM.render(
  <HashRouter>
    <AudioPlayerProvider>
       <App />
    </AudioPlayerProvider>
  </HashRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
